module.exports = __webpack_public_path__ + "img/CalvinL.dc633e41.jpeg";